import { render } from "./LogoIcon.svg?vue&type=template&id=16ade5ea"
const script = {}
script.render = render

export default script